// DAY-AGENTS-2026-10-03 §7: the lead's local time beside a send control -- "Their time: 3:12 pm Mountain" or
// "Their time: state unknown" -- and, when asked (showLift), when the quiet hours there lift.
import { localTimeLabel, quietLiftLabel, STATE_UNKNOWN_LABEL } from "./lib/localTime";

export default function LocalTimeBadge({ state, nowMs = Date.now(), showLift = false }) {
  const label = localTimeLabel(nowMs, state);
  const lift = showLift ? quietLiftLabel(nowMs, state) : null;
  return (
    <span data-testid="lead-local-time" style={{ fontSize: 12, color: label === STATE_UNKNOWN_LABEL ? "#b45309" : "#475569", marginRight: 6 }}>
      Their time: {label}
      {lift && <span data-testid="lead-quiet-lift" style={{ color: "#92400e" }}> · {lift}</span>}
    </span>
  );
}
